import React from 'react'
import {AiOutlineCaretDown , AiFillShopping , AiFillCaretRight } from "react-icons/ai"
import {GiMedicines} from "react-icons/gi"
import AddMedoc from './AddMedoc'
import MedocList from './MedocList'
import VentsListPharmacie from './VentsListPharmacie'

export  const dashbordPharmacie = [
    {
        title: 'Médicaments',
        cName : "pharmMedicament",
        titleIcon: <AiFillCaretRight />,
        content: [{
            icon: <GiMedicines /> ,
            contentText : "Ajouter un médicament",
            path:'addMedoc',
            destination: <AddMedoc/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Voir nos médicaments",
                path:'listMedoc',
                destination: <MedocList isArchived={false}/>
            },
            {
                icon: <AiFillShopping />,
                contentText : "Archive",
                path:'listArchivedMedoc',
                destination: <MedocList isArchived={true}/>
            }
        ]
    },
    {
        title: 'Ventes',
        cName : "ventesMedicament",
        titleIcon: <AiFillCaretRight />,
        content: [{
                icon: <GiMedicines /> ,
                contentText : "Liste des ventes",
                path:'listVents',
                destination: <VentsListPharmacie isValid={true}/>
            }
        ]
    }
]
